/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsAffordabilityCalculator204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsAffordabilityCalculator505Schema = z.any();

export const optionsAffordabilityCalculatorMutationResponseSchema = z.lazy(
  () => optionsAffordabilityCalculator204Schema
);
